import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InsuranceDeviantDriverFormModule } from './insurance-deviant-driver-form/insurance-deviant-driver-form.module';
import { InsurancePolicyHolderFormModule } from './insurance-policy-holder-form/insurance-policy-holder-form.module';
import { InsuranceRegularDriverFormComponent } from './insurance-regular-driver-form.component';
import {
    WucAlertModule,
    WucFormFieldLabelModule,
    WucFormFieldModule,
    WucInputRadioModule,
    WucSkeletonModule,
} from '@inshared/website-ui-components';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        InsurancePolicyHolderFormModule,
        InsuranceDeviantDriverFormModule,
        WucInputRadioModule,
        WucFormFieldLabelModule,
        WucFormFieldModule,
        WucSkeletonModule,
        WucAlertModule,
    ],
    exports: [
        InsuranceRegularDriverFormComponent,
    ],
    declarations: [
        InsuranceRegularDriverFormComponent,
    ],
})
export class InsuranceRegularDriverFormModule {}
